// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Shield = function Shield(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M1.98 1.312V8.43a5.172 5.172 0 001.168 3.153 5.921 5.921 0 001.908 1.54l.01.012L8 14.688l3.008-1.593.016-.013a5.9 5.9 0 001.825-1.5 5.172 5.172 0 001.168-3.152V1.312zm10.761 7.03a4.086 4.086 0 01-.921 2.489 4.668 4.668 0 01-1.441 1.183l-.013.01-2.377 1.258V2.724h4.751z"
    }))
  );
};

export default Shield;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Shield.js
// module id = 1051
// module chunks = 0